import { useTranslation } from 'react-i18next';
import { InfiosContainer, InfiosTextBlock } from '@infios/uikit/react';
import type { NotFoundData } from '../../interfaces/chat';
import styles from './ContentBlocks.module.css';

interface NotFoundBlockProps {
  data: NotFoundData;
}

export function NotFoundBlock({ data }: NotFoundBlockProps) {
  const { t } = useTranslation();
  const searchedFor = data.searchedFor ?? {};
  const entries = Object.entries(searchedFor).filter(([, value]) => value !== undefined && value !== null);

  return (
    <InfiosContainer type="card">
      <InfiosTextBlock slot="header" weight="bold">
        {t('ChatbotUI.OrderBlocks.NotFoundHeading')}
      </InfiosTextBlock>
      {entries.length > 0 ? (
        <div className={styles.rows}>
          {entries.map(([key, value]) => (
            <div className={styles.row} key={key}>
              <span className={styles.rowLabel}>{key}</span>
              <span>{String(value)}</span>
            </div>
          ))}
        </div>
      ) : null}
    </InfiosContainer>
  );
}
